import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";

@Component({
    selector: "app-auth-layout",
    imports: [RouterOutlet],
    templateUrl: "./auth-layout.html",
    styleUrl: "./auth-layout.scss",
})
export class AuthLayout {}
